module.exports = __webpack_public_path__ + "static/img/1.93bd684.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Infidelidad-Riesgos-Financieros/1.png
// module id = dVPB
// module chunks = 0